<template lang="pug">
  #purchase-order-pending-list

    //
    model-data-table(
      class='table-model-purchase-invoice-pending'
      no-data-text='Sin facturas por recepcionar.'
      :no-detail='!$can("VIEW_DETAIL_PURCHASE_INVOICE")'
      no-remove
      ref='table'
      remind-key='purchase-order-pending'
      v-bind='tableProps'
      @detail='submitDetail'
      )
      template( slot='actions' slot-scope='props' )
        v-btn-action(
          color='secondary'
          tooltip='Administrar numeros facturas'
          @click='submitAdding( props )'
          v-if='$can("CREATE_PCH_PURCHASE_INVOICE")'
          )
          v-icon filter_9_plus
        v-btn-action(
          color='success'
          tooltip='Registrar factura'
          @click='submitRegistry( props )'
          v-if='$can("CREATE_PCH_PURCHASE_INVOICE")'
          )
          v-icon add_to_photos
    //
    crud-dialog(
      content-class="grey lighten-3"
      no-confirm 
      title='Registrar factura de compra' 
      v-model='dialog' 
      )
      model-form(
        class="white"
        editable
        ref='form'
        no-reset
        submit-text='registrar'
        v-bind='formProps'
        v-model='selected'
        @submit='submitForm'
        )
        template( slot='table-items' slot-scope='props' )
          v-btn( 
            color='secondary' 
            :disabled='props.disabled' 
            @click='submitSaveDetail' 
            ) guardar &nbsp;
            v-icon save

    //
    crud-dialog(
      content-class="grey lighten-3 elevation-2"
      no-confirm 
      title='Modificar numero de factura de compra' 
      v-bind='dialogNumbersProps'
      v-model='dialogNumbers'            
      )
      model-form(
        class="white"
        editable
        ref='formNumbers'
        no-reset
        submit-text='cambiar'
        v-bind='formNumbersProps'
        v-model='selected'
        @submit='submitFormNumbers'
        )
          template( slot='footer-actions' )
            v-btn.ml-3( 
              block 
              color='success' 
              @click='submitAddNumber' 
              ) agregar
            v-btn.ml-3( 
              block 
              color='error'
              :disabled='formNumbersProps.fields[0].props.items && formNumbersProps.fields[0].props.items.length < 2' 
              @click='submitDeleteNumber' 
              ) eliminar
</template>

<script>
//
import { mapActions } from 'vuex'
import { CrudDialog, ModelDataTable, ModelForm, VBtnAction } from '@/components/reusable_components/next'
import translatorService from '@/services/translator'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'
import PurchaseOrderInvoiceNumModel from '@/models/Purchase/PchPurchaseOrderInvoiceNum'
import PurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'

//
import PurchaseOrderFilters from '@/views/Purchase/PchPurchaseOrder/partials/PurchaseOrderPendingFilters'
import PurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/partials/PurchaseOrderPendingHeaders'

//
import PurchaseInvoiceFields from './partials/PurchaseInvoiceCreateFields'
import PchPurchaseOrderInvoiceNumberFields from './PchPurchaseOrderInvoiceNumberFields'

//
export default {
  name: 'purchase-invoice-pending-list',
  components: {
    ModelDataTable,
    ModelForm,
    CrudDialog,
    VBtnAction,
  },
  computed: {

    /**
     * { function_description }
     * @return {Object} { description_of_the_return_value }
     */
    dialogNumbersProps() {
      return {
        width: 1080,
      }
    },

    /**
     * { function_description }
     * @return {<type>} { description_of_the_return_value }
     */
    selectedInvoiceNumberId() {
      return this.selected.invoice_number_id
    },

    /**
     * { function_description }
     * @return {Object} { description_of_the_return_value }
     */
    formProps() {
      return {
        fields: PurchaseInvoiceFields,
      }
    },

    /**
     * { function_description }
     * @return {Object} { description_of_the_return_value }
     */
    formNumbersProps() {
      return {
        fields: PchPurchaseOrderInvoiceNumberFields,
      }
    },

    /**
     * { function_description }
     * @return {Object} { description_of_the_return_value }
     */
    tableProps() {
      return {
        filters: PurchaseOrderFilters,
        headers: PurchaseOrderHeaders,
        service: PurchaseOrderModel,
        paramFilter: {
          pending_invoices: true,
        },
      }
    },
  },
  data() {
    return {
      dialog: false,
      dialogNumbers: false, 
      selected: {
        invoice_number_id: '',
      },
      selectedEdited: null,
    }
  },
  methods: {

    //
    ...mapActions('MenuesModule', {
      setTitleTopBar: 'setTitleTopBar',
    }),

    //
    ...mapActions('SnackbarModalModule', [
      'resetSnackbarState',
      'setErrorSnackbar',
      'setSuccessSnackbar',
    ]),

    /**
     * Shows the dialog numbers.
     * @param      {boolean}  [value=false]  The value
     */
    showDialogNumbers(value = false) {
      this.dialogNumbers = value
    },

    /**
     * { function_description }
     * @param {<type>}  error   The error
     */
    error(error) {
      this.setErrorSnackbar(translatorService(PurchaseInvoiceModel, error.response.data))
    },

    /**
     * Fetches an edited.
     * @param {<type>}  invoice_number  The invoice number
     */
    fetchEdited() { console.log('fetchEdited', this.selected)
      return PurchaseOrderInvoiceNumModel
        .modeler()
        .find(this.selected.invoice_number_id)
        .then(this.setEdited)
    },

    /**
     * { function_description }
     */
    refresh() {
      this.$refs.table.refresh()
    },

    /**
     * Sets the edited.
     * @param {<type>} model   The model
     */
    setEdited(model) {
      this.selectedEdited = model
      this.selected.selected = model.selected//.map(e => {
        //
        //e.net_price = 0
        //e.net_total = 0
        //e.quantity = 0
        //                
        //return e
      //})
    },

    /**
     * Shows the create invoice number success.
     */
    showCreateInvoiceNumberSuccess() { this.showSuccessSnackbar('Numero de factura agregado.') },

    /**
     * Shows the create invoice number error.
     */
    showCreateInvoiceNumberError() { this.showErrorSnackbar('Error al agregar numero de factura.') },

    /**
     * Shows the dialog number.
     * @param {<type>} val     The value
     */
    showDialogNumber(val) {
      this.dialogNumbers = val
    },

    /**
     * Shows the delete number success.
     */
    showDeleteNumberSuccess() {
      this.showSuccessSnackbar('Numero de factura eliminada.')
    },

    submitAddNumber() {
      this
        .toWaitNumbers(true)
        .then(this.toCreateInvoiceNumber)
        .then(this.toWaitNumbers)
    },

    /**
     * { function_description }
     * @param      {<type>}  event   The event
     */
    submitDetail(event) {
      this.$router.push({
        name: 'purchase-order-detail',
        params: { id: event.item.id },
      })
    },

    /**
     * { function_description }
     */
    submitFetchEdited() {
      this
        .toWait(true)
        .then(this.fetchEdited)
        .then(this.toWait)
    },

    /**
     * { function_description }
     */
    submitForm() {
      this
        .toWait(true)
        .then(this.toCreate)
        .then(this.toWait)
    },

    /**
     * { function_description }
     */
    submitFormNumbers() {
      this
        .$refs
        .formNumbers
        .setWait(true)
        .then(this.toAdd)
        .then(this.$refs.formNumbers.setWait)
    },

    /**
     * { function_description } 
     * @param {<type>}  event   The event
     */
    submitAdding(event) {

      //
      const available_invoice_numbers = event.item.available_pch_purchase_order_has_invoice_numbers
      const first_available_invoice_id = available_invoice_numbers.slice().shift().id

      //
      this.formNumbersProps.fields[0].props.items = available_invoice_numbers
      this.formNumbersProps.fields[0].trigger = () => this.submitFetchEdited()
      event.item['invoice_number_id'] = first_available_invoice_id

      //
      this.selected = event.item

      this.dialogNumbers = true

      //
      this.fetchEdited()
    },

    /**
     * Eliminar numero de factura de la orden pendiente
     * seleccionada
     * 
     * @param {object} event Factura seleccionada
     * @return {promise} Promesa de eliminacion de numero de factura
     */
    submitDeleteNumber(event) {
      return this
        .toWait(true)
        .then(this.toDeleteNumber)
        .then(this.toWait)
    },

    /**
     * { function_description }
     */
    submitSaveDetail() {
      this
        .toWait(true)
        .then(this.toUpdateEdited)
        .then(this.fetchEdited)
        .then(this.successDetail)
        .catch(this.error)
        .then(this.toWait)
    },

    /**
     * { function_description }
     *
     * @param      {<type>}  event   The event
     */
    submitRegistry(event) {

      // get requried select data
      const available_invoice_numbers = event.item.available_pch_purchase_order_has_invoice_numbers
      const branch_offices = event.item.pch_provider_branch_offices
      const has_available_invoices = available_invoice_numbers.length > 0
      const first_available_invoice_id = available_invoice_numbers.slice().shift().id

      //
      event.item['acc_cost_center_id'] = 1
      event.item['invoice_number_id'] = first_available_invoice_id
      event.item['extra_tax'] = 0
      event.item['is_exent'] = !!event.item.is_exent
      event.item['new_subtotal'] = event.item.net_subtotal
      event.item['payable'] = !!event.item.payable

      // set selected data
      this.formProps.fields[1].props.items = branch_offices
      this.formProps.fields[2].props.items = available_invoice_numbers
      this.formProps.fields[2].trigger = () => this.submitFetchEdited()

      // return dialog with data
      this.selected = event.item
      this.dialog = true

      //
      if (has_available_invoices) this.submitFetchEdited()

      // listen keyup
      document
        .querySelectorAll('[name="selected-table-field"]')
        .item(0)
        .onkeyup = (event) => {
          if (event.ctrlKey && event.which == 67) {
            this.submitSaveDetail()
          }
        }
    },

    /**
     * { function_description }
     */
    success() {
      this.setSuccessSnackbar('Factura de compra registrada exitosamente.')
      this.dialog = false
      this.selected = {}
    },

    /**
     * { function_description }
     */
    successAdd() {
      this.setSuccessSnackbar('Numero de factura de compra cambiado exitosamente.')
      this.dialogNumbers = false
      this.selected = {}            
    },

    /**
     * { function_description }
     */
    successDetail() {
      this.setSuccessSnackbar('Detalle de factura editado exitosamente.')       
    },

    /**
     * { function_description }
     *
     * @param      {<type>}  model   The model
     * @return     {<type>}  { description_of_the_return_value }
     */
    toAdd(model) {
      
      //
      this.selectedEdited.invoice_number = model.new_invoice_number

      //
      return this
        .selectedEdited
        .changeInvoiceNumber()
        .sync(this.selectedEdited.toChangeInvoiceNumber())
        .then(this.successAdd)
        .then(this.refresh)
        .catch(this.error)
    },

    /**
     * Returns a create representation of the object.
     *
     * @return     {<type>}  Create representation of the object.
     */
    toCreate() {
      return this
        .toUpdateEdited()
        .then(this.toCreateInvoice)
        .catch(this.error)
        .then(this.$refs.form.setWait)
        .then(this.refresh)
    },

    /**
     * Returns a create invoice representation of the object.
     * @return     {<type>}  Create invoice representation of the object.
     */
    toCreateInvoice() {
      return this
        .selected
        .toInvoice()
        .toCreate()
        .save()
        .then(this.success)
    },


    toCreateInvoiceNumber(event) {
      return event
        .invoiceNumber()
        .attach(event.toInvoiceNumber())
        .then(this.showCreateInvoiceNumberSuccess)
        .then(this.refresh)
        .then(this.fetchEdited)
        .then(this.showDialogNumbers)
        .catch(this.showCreateInvoiceNumberError)
    },

    /**
     * Returns a delete number representation of the object.
     * @return     {<type>}  Delete number representation of the object.
     */
    toDeleteNumber(event) {
      //console.log(this.selectedEdited)
      return this
        .selectedEdited
        .deleteInvoiceNumber()
        .then(this.showDeleteNumberSuccess)
        .then(this.refresh)
        .catch(this.showError)
        .then(this.showDialogNumber)
    },

    /**
     * Returns an update edited representation of the object.
     * @return     {<type>}  Update edited representation of the object.
     */
    toUpdateEdited() {

      //
      this.selectedEdited.pch_detail_purchase_order_has_invoice_numbers = this.selected.selected

      //
      return this
        .selectedEdited
        .toUpdate()
        .save()
    },

    /**
     * { function_description }
     * 
     * @param      {boolean}  [value=false]  The value
     * @return     {<type>}   { description_of_the_return_value }
     */
    toWait(value = false) {
      return this
        .$refs
        .form
        .setWait(value)
    },

    /**
     * { function_description }
     * 
     * @param      {boolean}  [value=false]  The value
     * @return     {<type>}   { description_of_the_return_value }
     */
    toWaitNumbers(value = false) {
      return this
        .$refs
        .formNumbers
        .setWait(value)
    },
  },
  watch: {

    /*selected: {
      deep: true,
      handler() {
        console.log('handle selected')
      },
    },

    'selected.invoice_number_id'(next, prev) {
      console.log(next, prev)
      if (next && next !== prev) this.submitFetchEdited()
    },*/
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('VIEW_ALL_PCH_PURCHASE_INVOICE_RECEIVE')) ctx.$router.push('/')
    })
  },
  beforeMount() {
    this.setTitle('Listado de facturas por recepcionar')
  },
}
</script>

<style>
  .table-model-purchase-invoice-pending tbody tr td:not(:last-child) {
    vertical-align: baseline;
    padding-bottom: 0;
  }
</style>
